import React, { Component } from 'react';

import './ReorderingWrapper.less';

interface Props {
  useVerticalDrag: boolean;
  stockItemId: number;
  dropOntoHandler: (arg0: number, arg1: number, arg2: boolean) => void;
}

export default class ReorderingWrapper extends Component<Props> {
  state = {
    hoverPriorDropZone: 0,
    hoverAfterDropZone: 0,
  };

  render() {
    return (
      <div
        className={
          this.props.useVerticalDrag
            ? 'reorderingWrapper--vertical'
            : 'reorderingWrapper--horizontal'
        }
        draggable={true}
        onDragStart={this.loadEventDataWithDragee()}
      >
        <div className="reorderingWrapper-cornerBox">
          <img
            alt=""
            className="reorderingWrapper-icon"
            src={
              __ASSETS_COMMON_IMAGES_URL__ +
              '/member/folders/6dots-nopadding.svg'
            }
            width={10}
            height={16}
          />
        </div>

        <div
          className="reorderingWrapper-dropToPriorZone"
          onDragOver={this.preventDefaultOnDragOver()}
          onDragEnter={this.hoverOverPriorDropZone()}
          onDragLeave={this.unhoverOverPriorDropZone()}
          onDrop={this.handleReorderingDrop(true)}
        />
        <div
          className="reorderingWrapper-dropToAfterZone"
          onDragOver={this.preventDefaultOnDragOver()}
          onDragEnter={this.hoverOverAfterDropZone()}
          onDragLeave={this.unhoverOverAfterDropZone()}
          onDrop={this.handleReorderingDrop(false)}
        />

        {this.state.hoverPriorDropZone > 0
          ? this.renderPriorInsertLine()
          : null}
        {this.state.hoverAfterDropZone > 0
          ? this.renderAfterInsertLine()
          : null}
        {this.props.children}
      </div>
    );
  }

  loadEventDataWithDragee() {
    return (event) => {
      event.dataTransfer.setData('text/plain', this.props.stockItemId);
    };
  }

  handleReorderingDrop(shouldInsertBefore) {
    return (event) => {
      /** This prevents the default drop behavior on Firefox to navigate to the dropped file */
      event.preventDefault();
      this.setState({ hoverPriorDropZone: 0, hoverAfterDropZone: 0 });
      const draggedStockItemId = parseInt(event.dataTransfer.getData('text'));
      this.props.dropOntoHandler(
        draggedStockItemId,
        this.props.stockItemId,
        shouldInsertBefore
      );
    };
  }

  hoverOverPriorDropZone() {
    return () => {
      this.setState({ hoverPriorDropZone: this.state.hoverPriorDropZone + 1 });
    };
  }

  unhoverOverPriorDropZone() {
    return () => {
      this.setState({ hoverPriorDropZone: this.state.hoverPriorDropZone - 1 });
    };
  }

  hoverOverAfterDropZone() {
    return () => {
      this.setState({ hoverAfterDropZone: this.state.hoverAfterDropZone + 1 });
    };
  }

  unhoverOverAfterDropZone() {
    return () => {
      this.setState({ hoverAfterDropZone: this.state.hoverAfterDropZone - 1 });
    };
  }

  preventDefaultOnDragOver() {
    return (event) => {
      event.preventDefault();
    };
  }

  renderPriorInsertLine() {
    return <div className="reorderingWrapper-insertPriorLine" />;
  }

  renderAfterInsertLine() {
    return <div className="reorderingWrapper-insertAfterLine" />;
  }
}
